/**
 * The line above a tool's title: its side and world, and the world's sentence
 * (registry GROUPS `about`). One renderer for the header in the app
 * (navigation.js) and each tool's static page (scripts/seo-pages.mjs). Pure.
 */

import { escapeHtml } from './html.js';

export function toolTrailHtml(room, group) {
  return (
    '<nav class="tool-head__trail" aria-label="Location">' +
    `<span>${escapeHtml(room.label)}</span><span class="tool-head__sep" aria-hidden="true">/</span><span>${escapeHtml(group.label)}</span>` +
    `</nav>${group.about ? `<p class="tool-head__world">${escapeHtml(group.about)}</p>` : ''}`
  );
}
